import React, { useCallback, useEffect, useState } from 'react';
import Form from "./Form";
import lien from './lien';
import './css/dash.scss';

const Connection = () => {
    const [messageLog, setMessageLog] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [mailError, setEmailError] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [probleme, setProbleme] = useState("non connecte");
    const [catcha, setCatcha] = useState("");
    const [catchaColler, setCatchaColler] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchUserToken();
    }, []);

    function catchaGenerate() {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

        function generateString(length) {
            let result = '';
            const charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }

            return result;
        }

        setCatcha(generateString(7));
    }

    function validateEmail(mail) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            setEmailError("");
            return true;
        }
        setEmailError("Vous avez entré une adresse email invalide!");
        return false;
    }

    const fetchUserToken = useCallback(async () => {
        // Vérifier si le JWT existe
        if (localStorage.getItem('jwt') === null || localStorage.getItem('jwt') === undefined) {
            return;
        }

        setIsLoading(true);

        try {
            let str = "" + localStorage.getItem('jwt');
            const response = await fetch(
                lien.url + "connection/user",
                {
                    method: "POST",
                    body: JSON.stringify({
                        jwt: str
                    }),
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            // Vérifier si la réponse est OK
            if (!response.ok) {
                setMessageLog(`Erreur du serveur: ${response.status}`);
                return;
            }

            const data = await response.json();

            if (!isNaN(data?.id)) {
                localStorage.setItem("utilisateur", data?.id);
                setMessageLog("Connexion réussie");
                setProbleme('connecte');
            } else {
                setMessageLog("Déconnecté - Session expirée");
            }
        } catch (error) {
            console.error("Erreur lors de la vérification du token:", error);
            setMessageLog("Erreur de connexion au serveur");
        } finally {
            setIsLoading(false);
        }
    }, []);

    const fetchConnection = useCallback(async (e) => {
        e.preventDefault();

        if (password.length < 3) {
            setPasswordError("Mot de passe trop court (minimum 3 caractères)");
            return;
        }

        setIsLoading(true);

        try {
            const response = await fetch(
                lien.url + "connection/login",
                {
                    method: "POST",
                    body: JSON.stringify({
                        "password": password,
                        "email": email
                    }),
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            // Vérifier si la réponse est OK
            if (!response.ok) {
                setMessageLog(`Erreur du serveur: ${response.status}`);
                setIsLoading(false);
                return;
            }

            const data = await response.json();

            if (!isNaN(data?.id)) {
                localStorage.setItem("utilisateur", data?.id);
                localStorage.setItem('jwt', data?.jwt);
                setMessageLog("Connexion réussie");
                setProbleme('connecte');
            } else {
                if (data.message && data.message.includes("vérifier votre email")) {
                    setMessageLog("Veuillez vérifier votre email avant de vous connecter");
                } else {
                    setMessageLog("Identifiant ou mot de passe incorrect");
                }
            }
        } catch (error) {
            console.error("Erreur lors de la connexion:", error);
            setMessageLog("Erreur de connexion au serveur");
        } finally {
            setIsLoading(false);
        }
    }, [email, password]);

    const handleLogout = () => {
        localStorage.removeItem('jwt');
        localStorage.removeItem('utilisateur');
        setProbleme('non connecte');
        setEmail('');
        setPassword('');
        setCatchaColler('');
        setCatcha('');
        setMessageLog('Vous avez été déconnecté');
    };

    return (
        <div className="connection-container">
            {(probleme === "connecte") ? (
                <div className="connected-view">
                    <Form />
                    <button onClick={handleLogout} className="logout-button">
                        Déconnexion
                    </button>
                </div>
            ) : (
                <div className="login-container">
                    <div className="containerColumn">
                        <h2>Connexion</h2>

                        {messageLog && (
                            <div className={messageLog.includes("réussie") ? "success-message" : "error-message"}>
                                {messageLog}
                            </div>
                        )}

                        <div className="form-group">
                            <input
                                id='email'
                                value={email}
                                placeholder={'Email'}
                                onChange={e => {
                                    setEmail(e.target.value);
                                    if (e.target.value) {
                                        validateEmail(e.target.value);
                                    }
                                }}
                                type={'text'}
                            />
                            {mailError && <p className="error">{mailError}</p>}
                        </div>

                        <div className="form-group">
                            <input
                                id='password'
                                value={password}
                                placeholder={'Mot de passe'}
                                onChange={e => {
                                    setPassword(e.target.value);
                                    if (e.target.value.length < 3) {
                                        setPasswordError("Le mot de passe doit comporter au moins 3 caractères");
                                    } else {
                                        setPasswordError("");
                                    }
                                }}
                                type={'password'}
                            />
                            {passwordError && passwordError !== "Le catcha est correct" && (
                                <p className="error">{passwordError}</p>
                            )}
                        </div>

                        <div className="forgot-password">
                            <a href="/forgot-password">Mot de passe oublié?</a>
                        </div>

                        <div className="captcha-section">
                            <button onClick={catchaGenerate} className="captcha-button">
                                Générer Captcha
                            </button>

                            {catcha && (
                                <>
                                    <div className="captcha-display" id="blur">{catcha}</div>
                                    <h3>Saisir le captcha</h3>
                                    <input
                                        value={catchaColler}
                                        placeholder={'Captcha'}
                                        onChange={e => {
                                            setCatchaColler(e.target.value);

                                            if (e.target.value !== catcha) {
                                                setPasswordError("Le captcha n'est pas correct");
                                            } else {
                                                setPasswordError("Le captcha est correct");
                                            }
                                        }}
                                        type={'text'}
                                    />

                                    {passwordError === "Le captcha est correct" && (
                                        <div className="success-message">Captcha correct</div>
                                    )}
                                </>
                            )}
                        </div>

                        {passwordError === "Le captcha est correct" ? (
                            <button
                                onClick={fetchConnection}
                                id='btnLogin'
                                className={isLoading ? "loading-button" : "login-button"}
                                disabled={isLoading}
                            >
                                {isLoading ? "Connexion en cours..." : "SE CONNECTER"}
                            </button>
                        ) : ""}

                        <div className="signup-link">
                            <p>Pas encore de compte? <a href="/inscription">S'inscrire</a></p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Connection;